<script setup lang="ts">
interface Props {
  variant?: 'light' | 'dark'
}

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<Props>(), {
  variant: 'light',
})

const innerStroke = computed(() => props.variant === 'dark' ? '#1A54C4' : '#8E8E7F')
const accentColor = computed(() => props.variant === 'dark' ? '#C7C7BE' : '#000F21')
</script>

<template>
  <svg
    viewBox="0 0 127 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M84.1379 49.2125C103.426 49.2125 119.063 64.8489 119.063 84.1375C119.063 103.426 103.426 119.062 84.1379 119.062C64.8494 119.062 49.2129 103.426 49.2129 84.1375C49.2129 64.8489 64.8494 49.2125 84.1379 49.2125Z"
      fill="#2D73FF"
    />
    <path
      d="M47.6246 15.8748C66.0364 15.8748 80.9621 30.8005 80.9621 49.2123C80.9621 67.6241 66.0364 82.5498 47.6246 82.5498C29.2128 82.5498 14.2871 67.6241 14.2871 49.2123C14.2871 30.8005 29.2128 15.8748 47.6246 15.8748Z"
      :stroke="innerStroke"
      stroke-miterlimit="10"
    />
    <path
      d="M47.625 9.52539C69.5438 9.52539 87.3125 27.2941 87.3125 49.2129C87.3125 71.1317 69.5438 88.9004 47.625 88.9004C25.7062 88.9004 7.9375 71.1317 7.9375 49.2129C7.9375 27.2941 25.7062 9.52539 47.625 9.52539Z"
      :stroke="accentColor"
      stroke-miterlimit="10"
      stroke-dasharray="2 2"
    />
    <path
      d="M45.8046 47.4716C44.8429 48.477 44.8784 50.0716 45.8837 51.0333C46.8891 51.995 48.4837 51.9595 49.4454 50.9542C50.4071 49.9488 50.3716 48.3542 49.3663 47.3925C48.3609 46.4308 46.7663 46.4662 45.8046 47.4716ZM82.3171 82.3966C81.3554 83.402 81.3908 84.9966 82.3962 85.9583C83.4016 86.92 84.9962 86.8845 85.9579 85.8792C86.9196 84.8738 86.8841 83.2792 85.8788 82.3175C84.8734 81.3558 83.2788 81.3912 82.3171 82.3966ZM47.625 49.2129L47.2985 49.5542L83.811 84.4792L84.1375 84.1379L84.464 83.7966L47.9515 48.8716L47.625 49.2129Z"
      :fill="accentColor"
    />
  </svg>
</template>
